import { render, staticRenderFns } from "./AddTrailerSidebar.vue?vue&type=template&id=5db5b184"
import script from "./AddTrailerSidebar.vue?vue&type=script&lang=js"
export * from "./AddTrailerSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports